var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTurkmenistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0.874023C14.8054 0.874023 13.6417 1.00609 12.5218 1.25434L11.8262 16.874L12.5218 32.4936C13.6417 32.7419 14.8054 32.874 16 32.874C24.8365 32.874 32 25.7105 32 16.874C31.9999 8.03746 24.8365 0.874023 16 0.874023V0.874023Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17387 6.09694C1.58112 8.94044 0 12.7223 0 16.8737C0 21.0251 1.58119 24.8069 4.17394 27.6506L4.86956 16.8737L4.17387 6.09694Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4007 12.9428C24.1879 10.7487 23.3035 8.36237 21.4056 7.17387C21.7469 7.2183 22.0887 7.29868 22.4259 7.41962C24.9574 8.32787 26.2732 11.1161 25.365 13.6475C24.4567 16.1791 21.6685 17.4948 19.1371 16.5866C18.7997 16.4656 18.4848 16.3102 18.1931 16.1276C20.4137 16.4167 22.6135 15.1369 23.4007 12.9428V12.9428Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0351 6.57247L18.351 7.45634L17.2992 7.07891L17.9283 8.00253L17.2444 8.88628L18.3172 8.5734L18.9464 9.4969L18.9802 8.37991L20.0531 8.06697L19.0013 7.68966L19.0351 6.57247Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8813 9.45232L20.1973 10.3361L19.1454 9.95869L19.7746 10.8823L19.0906 11.7661L20.1634 11.4531L20.7926 12.3768L20.8265 11.2597L21.8993 10.9467L20.8475 10.5693L20.8813 9.45232Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7782 7.62114L15.0942 8.50489L14.0424 8.12758L14.6716 9.05114L13.9875 9.93495L15.0603 9.62201L15.6896 10.5456L15.7234 9.42858L16.7962 9.11564L15.7444 8.7382L15.7782 7.62114Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7033 10.9198L15.0193 11.8036L13.9675 11.4262L14.5967 12.3499L13.9126 13.2336L14.9855 12.9207L15.6147 13.8442L15.6485 12.7272L16.7214 12.4143L15.6695 12.0369L15.7033 10.9198Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.843 12.0466L18.1589 12.9303L17.1071 12.5529L17.7364 13.4766L17.0522 14.3603L18.1252 14.0474L18.7544 14.971L18.7882 13.8539L19.8611 13.541L18.8091 13.1636L18.843 12.0466Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17383 6.09725V27.6508C6.35383 30.0417 9.24945 31.7682 12.5216 32.4936V1.25437C9.24939 1.97975 6.35389 3.70631 4.17383 6.09725V6.09725Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35996 9.298L5.9624 8.25688V6.78457L7.35996 5.74351H9.33653L10.7341 6.78457V8.25688L9.33653 9.298H7.35996Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34828 5.74351H7.35996L5.9624 6.78457V7.50438H8.34828V5.74351Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34839 9.29776H9.33664L10.7342 8.25663V7.50557H8.34839V9.29776Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35996 28.0044L5.9624 26.9633V25.4911L7.35996 24.45H9.33653L10.7341 25.4911V26.9633L9.33653 28.0044H7.35996Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34828 24.45H7.35996L5.9624 25.4911V26.2109H8.34828V24.45Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34839 28.0042H9.33664L10.7342 26.9631V26.2121H8.34839V28.0042Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35899 18.6517L5.96143 17.6105V16.1383L7.35899 15.0972H9.33555L10.7331 16.1383V17.6105L9.33555 18.6517H7.35899Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7823 20.9417H10.1736V20.333H9.1039L8.34753 19.5766L7.59122 20.333H6.52153V20.9417H5.91284V22.1591H6.52153V22.7678H7.59115L8.34759 23.5242L9.1039 22.7678H10.1736V22.1591H10.7823V20.9417Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7823 11.5888H10.1736V10.9801H9.1039L8.34753 10.2237L7.59122 10.9801H6.52153V11.5888H5.91284V12.8062H6.52153V13.4149H7.59115L8.34759 14.1714L9.1039 13.4149H10.1736V12.8062H10.7823V11.5888Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65259 16.1781H9.04389V17.5694H7.65259V16.1781Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34821 12.8927C8.73239 12.8927 9.04383 12.5812 9.04383 12.197C9.04383 11.8128 8.73239 11.5014 8.34821 11.5014C7.96403 11.5014 7.65259 11.8128 7.65259 12.197C7.65259 12.5812 7.96403 12.8927 8.34821 12.8927Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34821 22.2462C8.73239 22.2462 9.04383 21.9347 9.04383 21.5505C9.04383 21.1664 8.73239 20.8549 8.34821 20.8549C7.96403 20.8549 7.65259 21.1664 7.65259 21.5505C7.65259 21.9347 7.96403 22.2462 8.34821 22.2462Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.874023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkmenistan);
export default __webpack_public_path__ + "static/media/turkmenistan.548b0337.svg";
export { ForwardRef as ReactComponent };